// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__wVUak","employee-header-item":"Header_employee-header-item__+rZ0z"};